import type { CarInputState } from '../types';

const DRIVING_CODES = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'KeyW',
  'KeyS',
  'KeyA',
  'KeyD',
]);

export class KeyboardInput {
  private readonly pressed = new Set<string>();
  private escapePending = false;
  private readonly onKeyDown = (event: KeyboardEvent): void => {
    if (
      event.target instanceof Element &&
      (event.target.closest('input, textarea, select') ||
        (event.target instanceof HTMLElement && event.target.isContentEditable))
    )
      return;
    if (DRIVING_CODES.has(event.code)) {
      event.preventDefault();
      this.pressed.add(event.code);
    }
    if (event.code === 'Escape' && !event.repeat) {
      event.preventDefault();
      this.escapePending = true;
    }
  };
  private readonly onKeyUp = (event: KeyboardEvent): void => {
    this.pressed.delete(event.code);
  };

  constructor() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);
  }

  read(): CarInputState {
    return {
      accelerate: this.pressed.has('ArrowUp') || this.pressed.has('KeyW'),
      brake: this.pressed.has('ArrowDown') || this.pressed.has('KeyS'),
      turnLeft: this.pressed.has('ArrowLeft') || this.pressed.has('KeyA'),
      turnRight: this.pressed.has('ArrowRight') || this.pressed.has('KeyD'),
    };
  }

  takeEscape(): boolean {
    const pending = this.escapePending;
    this.escapePending = false;
    return pending;
  }

  clear(): void {
    this.pressed.clear();
    this.escapePending = false;
  }

  dispose(): void {
    this.clear();
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('keyup', this.onKeyUp);
  }
}
